import React from 'react';
import styles from './UpcomingCollections.module.css';

const UpcomingCollections = ({ clients = [] }) => {
  const upcomingClients = clients.filter(client => {
    if (client.remainingAmount <= 0) return false;
    
    let nextDue;
    if (client.nextDueDate) {
      nextDue = new Date(client.nextDueDate);
    } else {
      nextDue = new Date(client.lastPaymentDate || client.createdAt || client.startDate);
      nextDue.setDate(nextDue.getDate() + 15);
    }
    
    if (isNaN(nextDue.getTime())) return false;
    
    const today = new Date();
    today.setHours(0,0,0,0);
    nextDue.setHours(0,0,0,0);
    
    const diffTime = nextDue.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    return diffDays >= 0 && diffDays <= 5;
  }).sort((a, b) => {
    const dueA = new Date(a.nextDueDate || a.startDate).getTime();
    const dueB = new Date(b.nextDueDate || b.startDate).getTime();
    return dueA - dueB;
  });

  if (upcomingClients.length === 0) return null;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3 className={styles.title}>Upcoming Payment Collections</h3>
        <span className={styles.badge}>{upcomingClients.length} Due Soon</span>
      </div>
      <div className={styles.list}>
        {upcomingClients.map(c => {
          let nextDue;
          if (c.nextDueDate) {
            nextDue = new Date(c.nextDueDate);
          } else {
            nextDue = new Date(c.lastPaymentDate || c.createdAt || c.startDate);
            nextDue.setDate(nextDue.getDate() + 15);
          }
          
          const today = new Date();
          today.setHours(0,0,0,0);
          nextDue.setHours(0,0,0,0);
          const diffDays = Math.ceil((nextDue.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
          
          let dayLabel = `In ${diffDays} days`;
          if (diffDays === 0) dayLabel = 'Today';
          if (diffDays === 1) dayLabel = 'Tomorrow';

          return (
            <div key={c.id} className={styles.item}>
              <div className={styles.info}>
                <span className={styles.name}>{c.clientName || c.name}</span>
                <span className={styles.channel}>{c.channelName || c.channel}</span>
              </div>
              <div className={styles.dueInfo}>
                <span className={styles.amount}>₹{(c.remainingAmount || 0).toLocaleString('en-IN')}</span>
                <span className={styles.days}>{dayLabel}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default UpcomingCollections;
